<template lang="pug">
  .slide(:class="{active}" ref="container")
    component(:is="slideContent" ref="slide")
</template>

<script>
import AnimationManager from '../scripts/AnimationManager'

export default {
  name: 'slide',
  props: [
    'slideContent',
  ],
  data () {
    return {
      active: false,
    }
  },
  mounted () {
  },
  computed: {
  },
  methods: {
    setActive () {
      this.active = true
      if (AnimationManager.getObjectInView(this.$refs.container)) {
        this.$refs.slide.playAnimation()
      } else {
        AnimationManager.onEnterView(this.$refs.container, this.onEnterView)
      }
    },
    setInactive () {
      this.active = false
    },
    onEnterView () {
      this.$refs.slide.playAnimation()
    },
  },
  components: {
  },
}
</script>

<style scoped lang="scss">
.slide {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  opacity: 0;
  transition: opacity .25s ease-in;
  &.active {
    opacity: 1;
    z-index: 2;
  }
}
</style>
